<template>
  <div id="app">
    <router-view/>
    <addToCartAnimation ref="addToCartAnimationRef"></addToCartAnimation>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

import addToCartAnimation from './components/add-to-cart-animation/add-to-cart-animation'
let tui = require("./assets/js/uni.webview")

export default {
  name: 'App',
  components: {
    addToCartAnimation
  },
  created() {
    const uni = tui.uni
    const that = this
    window.webviewBack = function () {
      const pathname = window.location.pathname
      if (pathname === '/home' && typeof window.stop === 'function') {
        window.stop()
      }
      if (pathname === '/') {
        return uni.navigateBack()
      }
      window.history.back()
    }
    window.webviewToPage = function (url) {
      window.location.href = window.origin + url
    }
    window.appWechatLogin = function (unionid) {
      that.$router.push({
        path: '/wechat-auth2',
        query: {
          unionid
        }
      })
    }
    window.appGoogleLogin = function (code) {
      console.log('appGoogleLogin', code)
      that.$router.push({
        path: '/google-auth2',
        query: {
          code
        }
      })
    }
    window.appFacebookLogin = function (code) {
      console.log('appFacebookLogin', code)
      that.$router.push({
        path: '/facebook-auth2',
        query: {
          code
        }
      })
    }
    window.appAppleLogin = function (user) {
      console.log('appAppleLogin', user)
      that.$router.push({
        path: '/apple-auth2',
        query: {
          user
        }
      })
    }
    const localAppSystemInfo = window.localStorage.getItem('appSystemInfo')
    if (window.appSystemInfo) {
      window.localStorage.setItem('appSystemInfo', JSON.stringify(window.appSystemInfo))
      this.changeAppSystemInfo(window.appSystemInfo)
    } else if (localAppSystemInfo && typeof localAppSystemInfo === "string") {
      const val = JSON.parse(localAppSystemInfo)
      window.appSystemInfo = val
      this.changeAppSystemInfo(val)
    }
    this.changeUni(uni)
    uni.getEnv(res => this.changeEnv(res))
  },
  methods: {
    ...mapActions(['changeUni', 'changeEnv', 'changeAppSystemInfo'])
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Do+Hyeon&family=Lexend:wght@300;400;500;600;700;800;900&display=swap');

@font-face {
  font-family: 'Martian B Thai';
  src: url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.eot');
  src: url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.eot?#iefix') format('embedded-opentype'),
  url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.woff2') format('woff2'),
  url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.woff') format('woff'),
  url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.ttf') format('truetype'),
  url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.svg#MartianBThai-Regular') format('svg');
  font-weight: normal;
  font-style: normal;
}

#app {
  width: 100%;
  height: 100%;
  position: relative;
}

.text-center {
  text-align: center !important;
}

.text-start {
  text-align: left !important;
}

*, *::before, *::after {
  box-sizing: border-box;
}

body {
  width: 100%;
  margin: 0;
  padding: 0 !important;
  background-color: #FFFDF0;
  overflow: initial !important;
  color: #000;
  font-family: 'Lexend', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  /* user-select: none; */
}

body, input, textarea, button, select {
  line-height: normal;
  font-family: 'Lexend', sans-serif;
}

body *:not(.fa):not([class^="fa-"]):not([class*=" fa-"]):not([class^="el-icon-"]):not([class*=" el-icon-"]) {
  font-family: 'Lexend', sans-serif !important;
}


ul, ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

a {
  color: #000000;
  text-decoration: none;
}

body {
  /* padding-top: 211px !important; */
  overflow-x: hidden;
}

.body_top {
  padding-top: 211px !important;
}

.pointer {
  cursor: pointer;
}

@media only screen and (max-width: 1299px) {
  body {
    padding-top: 180px !important;
  }
}

@media only screen and (max-width: 768px) {
  body {
    padding-top: 0 !important;
  }

  .botPage {
    padding-bottom: 86px !important;
  }
}

@media only screen and (max-width: 479px) {
  body {
    /*padding-top: 94px !important;*/
  }
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.popupbt{
  display: none;
}

</style>

<style lang="less">
@import "./assets/query/popup";
@media only screen and (max-width: 768px) {
  .el-select-dropdown .el-select-dropdown__wrap {
    margin: 0 !important;
  }

  .el-select-dropdown__item {
    font-size: 14px !important;
    height: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue